import EventAvailableIcon from '@mui/icons-material/EventAvailable';

const MaterialEventAvailableIcon = (props) => {
  return <EventAvailableIcon htmlColor="#1F1f1f" {...props} />;
};

export default MaterialEventAvailableIcon;
